import React from "react";
import { useNavigate } from "react-router-dom";

import CommonPopup from "..";
import CommonButton from "../../Button";

import DormancyBlueCheck from "../../../assets/img/dormancy-blue-check.png";

type Props = { popup?: string; onClose?: () => void };

export default function CheckWorkSpacePopup({ popup, onClose }: Props) {
  const navigate = useNavigate();
  return (
    <CommonPopup
      title="근무 위치 변경"
      isOpen={popup === "checkWorkSpace"}
      padding={0}
      unUseHorizonRule
    >
      <div className="p-5 pt-0 ">
        <div className="flex flex-col gap-[25px] pb-5 items-center">
          <img
            src={DormancyBlueCheck}
            alt="dormancy-blue-check"
            className="h-[80px]"
          />
          <div className="whitespace-pre-line text-xl font-medium text-center">
            {
              "근무 위치가\n확인되지 않아 초기화 되었어요.\n건물을 재설정 해주세요."
            }
          </div>
        </div>
      </div>
      <CommonButton
        className="w-full h-bottom-button rounded-none"
        onClick={() => {
          navigate("/myinfo/change/building", { state: { invalid: true } });
          onClose?.();
        }}
      >
        근무 위치 다시 고르기
      </CommonButton>
    </CommonPopup>
  );
}
